import { useCallback, useState } from 'react';

import { getTimezonesEndpoint } from './endpoints';

export const useRoutingRuleModalService = () => {
	const [isTimezonesLoading, setIsTimezonesLoading] = useState(false);

	const getTimezones = useCallback(() => {
		setIsTimezonesLoading(true);

		return getTimezonesEndpoint().finally(() => setIsTimezonesLoading(false));
	}, []);

	return { isTimezonesLoading, getTimezones };
};
